import { UpdatePage } from '@components/molecules';
import { TextFieldElement, SwitchElement, useForm } from 'react-hook-form-mui';
import API from '@apps/localization/services/country';
import APIRegion from '@apps/localization/services/region';
import { ModelProps } from '@/types';
import {
  CountrySchema,
  CountrySchemaType,
} from '@apps/localization/schemas/country';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const formContext = useForm<CountrySchemaType>({
    resolver: zodResolver(CountrySchema),
    defaultValues: { is_active: true },
  });
  return (
    <UpdatePage
      schema={CountrySchema}
      api={API}
      title={t('Country')}
      modelProps={modelProps}
      formcontext={formContext}
      canSaveAndContinue
      keepValues={['region']}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <AsyncAutocompleteElement
          api={APIRegion.select}
          name="region"
          label={t('Region')}
          // required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement name="name" label={t('Name')} fullWidth required />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <SwitchElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </UpdatePage>
  );
}
